import {type PersonnelOverviewEntity} from './types/PersonnelOverviewEntity';
import {useSessionBoolean} from './useSessionBoolean';

const SESSION_KEY_PREFIX = 'personnel-overview-default-seeded';

export function useHasDefaultBranchBeenSeeded(entity: PersonnelOverviewEntity) {
  return useSessionBoolean(`${SESSION_KEY_PREFIX}:${entity}`);
}
